import { Component } from '@angular/core'

@Component({
  selector: 'se-po-persona-picker-docs',
  templateUrl: './persona-picker-docs.component.html',
  styleUrls: ['./persona-picker-docs.component.scss'],
  standalone: false,
})
export class PersonaPickerDocsComponent {
  public headers: string[] = [
    'Property',
    'Type',
    'Description',
  ]
  public personaPickerComponent: any = [
    {
      Property: '@Input() profiles',
      Type: 'Households.UserProfile[]',
      Description: 'List of personas to choose from',
    },
    {
      Property: '@Input() profilesFrames',
      Type: 'Households.UserProfileFrames[]',
      Description: 'List of personas frames to display additional info',
    },
    {
      Property: '@Input() requiredProfileFields',
      Type: `{ minor?: ('address'|'phone'|'graduation_year')[], adult?: ('address'|'phone')[] }`,
      Description: 'Optional additional required profile fields per minor/adult profile; missing values show “Missing Information”.',
    },
    {
      Property: '@Output() edit',
      Type: 'Households.UserProfile',
      Description: 'Edit button clicked for a persona',
    },
    {
      Property: '@Output() pick',
      Type: 'Households.UserProfile',
      Description: 'Persona has been picked',
    },
    {
      Property: '@Output() action',
      Type: 'Households.UserProfile, action: {name: string}',
      Description: 'Action chosen',
    }
  ]
}
